import subContext from './sub-context.js'
import itemEmpty from './item-empty.js'

/**
 * Builds a sub list.
 *
 * @param context
 * @return {{mutations: {}, state: {}, getters: {}, actions: {}, namespaced: boolean}}
 */
function buildSubList (context) {
  const {resource, $name, $namespace, $parentNamespace} = context;
  const RESET = 'LIST_RESET';
  const SET_ITEMS = 'LIST_SET_ITEMS';
  const SET_ERROR = 'LIST_SET_ERROR';
  const UPDATE_FILTER = 'UPDATE_FILTER';

  if (!resource.operations.list) {
    console.log(resource)
    throw new Error('Logic exception? Resource has no list URL: ' + resource.name)
  }

  return {
    namespaced: true,
    state: {
      $name,
      $namespace,
      $parentNamespace,
      error: '',
      items: {},
      uuids: []
    },
    actions: {
      load: ({ commit, dispatch, state}) => {
        const uri = resource.operations.list.url + '?' + state.uuids.map((value) => 'uuid[]=' + value).join('&')
        dispatch('api/fetch', {uri}, { root: true })
          .then(response => response.json())
          .then((data) => {
            // Resort items.
            const items = {}
            data['hydra:member'].map((item) => {
              items[item.uuid] = item
            })
            commit(SET_ITEMS, items)
          })
          .catch((e) => {
            commit(SET_ERROR, e.message)
          })
      },
      reset: ({commit}) => {
        commit(RESET)
      },
      setUuids: ({ commit, dispatch }, payload) => {
        // make list unique.
        payload = payload.filter((value, index, self) => {
          return self.indexOf(value) === index;
        })
        commit(UPDATE_FILTER, payload)
        dispatch('load')
      }
    },
    getters: {
      error: state => state.error,
      item: state => (uuid) => {
        if (!uuid) {
          return itemEmpty(resource.operations.list.output.items.properties)
        }
        // Could be a hydra id value.
        if (uuid && uuid.match(/\//)) {
          uuid = uuid.split('/').pop()
        }

        return state.items[uuid] || itemEmpty(resource.operations.list.output.items.properties)
      },
      uuids: state => state.uuids,
    },
    mutations: {
      [RESET] (state) {
        Object.assign(state, {
          error: '',
          items: {},
          uuids: []
        })
      },
      [SET_ERROR] (state, error) {
        Object.assign(state, { error })
      },
      [SET_ITEMS] (state, items) {
        Object.assign(state, { items })
      },
      [UPDATE_FILTER] (state, uuids) {
        state.uuids = uuids
      }
    }
  }
}

/**
 * Build a reference store for linked object references (used in list stores).
 *
 * @param {ModuleBuilderContext} context
 * @param {object} properties
 *
 * @return object
 */
export default function buildReferenceList (context, properties) {
  const {$name, $namespace, $parentNamespace} = context;
  const references = {}
  const referenceNames = []
  Object.keys(properties).map((propName) => {
    const property = properties[propName]
    const reference = (property.type === 'array') ? property.items.reference : property.reference
    if (reference) {
      const resource = context.parsed[reference]
      if (resource && resource.operations.list && resource.operations.list.parameters.some((parameter) => parameter.name === 'uuid[]')) {
        references[propName] = buildSubList(subContext(context, propName, {resource}))
        referenceNames.push(propName)
      }
    }
  });

  if (referenceNames.length === 0) {
    return undefined
  }

  return {
    namespaced: true,
    state: {
      $name,
      $namespace,
      $parentNamespace
    },
    modules: {
      ...references
    },
    actions: {
      /**
       * @param {function} commit
       * @param {function} dispatch
       * @param {array}    data     The items of the parenting resource.
       */
      loadFor: ({ commit, dispatch }, data) => {
        referenceNames.map((propName) => {
          if (data.length) {
            // Create an uuid filter list.
            const uuids = []
            const convertUuids = (value) => {
              if (Array.isArray(value)) {
                value.map(convertUuids)
                return
              }
              uuids.push(value ? value.split('/').pop() : undefined)
            }
            data.map((item) => convertUuids(item[propName]));
            dispatch(propName + '/setUuids', uuids.filter((uuid) => !!uuid))
          }
        })
      },
      reset: ({ commit, dispatch }, data) => {
        referenceNames.map((propName) => {
          if (data[propName]) {
            dispatch(propName + '/reset', data[propName])
          }
        })
      }
    }
  }
}
